import SEvents from "./SEvents_web"
export default SEvents
